import { Middleware, MiddlewareAPI, createAction } from '@reduxjs/toolkit';
import { advancedReportQueryApi } from 'app/apis/advanced-reports/advanced-report-query-api';
import { selectSite } from 'features/topbar/selectedSiteSlice';

export const advancerReportsSiteIdChangedHandler: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (action.type === selectSite.type) {
      api.dispatch(advancedReportQueryApi.util.resetApiState());
    }
    return next(action);
  };

export const resetAdvancedReports = createAction('advancedreports/reset');
